/* Golden framing uses projected mesh vertices, never the canvas or a bounding sphere.
   Extends the current house viewer so its existing compressor and ink rendering stay intact. */
(() => {
  const watched = new WeakSet();
  const sizePromo = cell => {
    const height = cell.querySelector('.srlm-featured__item-info')?.getBoundingClientRect().height || 0;
    const value = height + 'px';
    if (cell.style.getPropertyValue('--promo-info-height') !== value) cell.style.setProperty('--promo-info-height', value);
  };
  const sizes = new ResizeObserver(entries => entries.forEach(entry => sizePromo(entry.target)));
  const scan = () => {
    document.querySelectorAll('.gg-card gg-model-viewer, [data-promo-model] gg-model-viewer').forEach(v => {
      if(v.getAttribute('display') !== 'wireframe') v.setAttribute('display','wireframe');

    });
    document.querySelectorAll('gg-model-viewer[display="wireframe"]').forEach(v => {
      if(v.getAttribute('line-color') !== '#eee6ce') v.setAttribute('line-color','#eee6ce');
    });
    document.querySelectorAll('[data-promo-model]').forEach(model => {
    const cell = model.parentElement;
    sizePromo(cell);
    if (!watched.has(cell)) { watched.add(cell); sizes.observe(cell); }
  });
  };
  scan();
  new MutationObserver(scan).observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['href', 'display', 'line-color']});
  customElements.whenDefined('gg-model-viewer').then(() => {
    const proto = customElements.get('gg-model-viewer').prototype;
    const fit = proto.fit;
    proto.fit = function () {
      fit.call(this);
      if (document.documentElement.dataset.houseGolden !== 'on' || !this.ortho || !this.radius || !this.pose || !this.group || !this.spin) return;
      const plate=this.closest('.gg-plate');
      const manual=plate && window.ggGoldenFrame?.manual(plate);
      const savedSpin = this.spin.rotation.clone();
      const savedScroll = this.scrollGroup.rotation.y;
      const savedScale = this.group.scale.clone();
      const savedPosition = this.scrollGroup.position.clone();
      this.spin.rotation.set(this.tilt || 0, 0, 0);
      this.scrollGroup.rotation.y = 0;
      this.scrollGroup.position.set(0, 0, 0);
      this.group.scale.setScalar(1);
      this.scene.updateMatrixWorld(true);
      this.camera.updateMatrixWorld(true);
      const point = this.group.position.clone();
      let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
      this.pose.traverse(mesh => {
        if (!mesh.isMesh) return;
        const positions = (mesh.userData.source || mesh.geometry)?.attributes?.position;
        if (!positions) return;
        for (let i = 0; i < positions.count; i++) {
          point.fromBufferAttribute(positions, i).applyMatrix4(mesh.matrixWorld).project(this.camera);
          minX = Math.min(minX, point.x); maxX = Math.max(maxX, point.x);
          minY = Math.min(minY, point.y); maxY = Math.max(maxY, point.y);
        }
      });
      const phi = (1 + Math.sqrt(5)) / 2;
      const cw=this.camera.right-this.camera.left,ch=this.camera.top-this.camera.bottom;
      const context=window.ggProductFraming?.describe(this)||{};
      const plan=window.ggProductFraming?.fit(cw,ch,(maxX-minX)*cw/2,(maxY-minY)*ch/2,context.category,null,context.detail);
      const scale = plan?.scale ?? Math.min(2 / phi / (maxX - minX), 2 / phi / (maxY - minY));
      if (Number.isFinite(scale) && scale > 0) {
        this.group.scale.setScalar(scale * (manual?.s ?? 1));
        this.scrollGroup.position.set(
          (-(minX + maxX) / 4 * scale * (manual?.s ?? 1) + (manual?.x || 0)/100) * (this.camera.right - this.camera.left),
          (-(minY + maxY) / 4 * scale * (manual?.s ?? 1) - (manual?.y || 0)/100) * (this.camera.top - this.camera.bottom), 0);
        this.dataset.modelFraming = manual ? 'manual-current-media' : 'projected-geometry';
        this.dataset.objectProfile=context.category||'other';
        this.stillKept = false;
      } else {
        this.group.scale.copy(savedScale);
        this.scrollGroup.position.copy(savedPosition);
      }
      this.spin.rotation.copy(savedSpin);
      this.scrollGroup.rotation.y = savedScroll;
      this.requestRender();
    };
    const pose = proto.applyPose;
    proto.applyPose = function () { pose.call(this); if (this.radius) this.fit(); };
    document.querySelectorAll('gg-model-viewer').forEach(v => v.fit?.());
  });
})();


